import styled from 'styled-components';
import { H1, H2, B1, SectionParent, BlueButton } from '../StyledComponents';
import MiniSearch from 'minisearch';
import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
const SectionOne = styled(SectionParent)`
  background-color: #ffffff;
  padding-bottom: 5rem;
  padding-top: 2rem !important;
  text-align: center;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 2rem !important;
  }
  width: 100%;
  display: grid;
`;
const TopSection = styled(SectionParent)`
  background-image: linear-gradient(34deg, #9a6ad3 0%, #5847a0 100%);
  display: grid;
  margin-top: 6rem !important;
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
`;
const SectionTop = styled.div`
  padding: 2rem 14rem;
  @media (max-width: 1100px) {
    padding: 2rem;
  }
`;
const HeadingSection = styled(H1)`
  font-size: 48px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  text-align: center;
  padding-bottom: 1rem;
`;
const SearchBar = styled.div`
  height: 3rem;
  width: 100%;
`;
const FaqQuestion = styled(H2)`
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #294661;
  font-family: 'Nunito Sans', sans-serif;
  text-align: left;
  padding-bottom: 1rem;
  @media (min-width: 1024px) {
    font-size: 21px;
  }
  @media (max-width: 520px) {
    text-align: left;
  }
`;
const FaqContainer = styled.div`
  display: grid;
  /* justify-items: center; */
  padding: 2rem 14rem;
  @media (max-width: 1100px) {
    padding: 2rem;
  }
`;
const FaqAnswer = styled(B1)`
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #7f8495;
  font-family: 'Nunito Sans', sans-serif;
  text-align: left;
  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

const BlueButtonWrapper = styled.div`
  justify-content: center;
  display: flex;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 75%;
  padding-left: 1rem;
  outline: none;
  border: none;
  :focus {
    color: #294661;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    background-image: none;
  }
  box-shadow: none;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
  }
  line-height: 1.43;
  ::placeholder {
    color: #294661;
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 50px;
  padding: 0.475rem 0.75rem 0.475rem 1.5rem;
  border-radius: 4px;
  background-position-y: center;
  background-position-x: 0.5rem;
  opacity: 1;
  background-repeat: no-repeat;
  text-indent: 20px;
  background-size: 18px 18px;
`;

const BlueButtonNew = styled(BlueButton)`
  color: #54586b;
  background: #e3ebfb;
`;

const SorryNoContent = styled.div`
  padding-top: 10rem;
  padding-bottom: 8rem;
  color: #54586b;
  font-size: 28px;
`;
export default class FaqSectionOne extends React.Component<any, any> {
  state = {
    searchWord: '',
    loadLimit: 5,
    results: this.props.query.edges
      .filter((item: any) => item?.node?.answer?.json)
      .map((item: any) => {
        return {
          id: item.node.id,
          question: item.node.question,
          answer_json: item.node.answer.json,
          answer_text: item.node.answer.content
            .map((contentMap: any) => contentMap.value)
            .join(' '),
        };
      }),
    searchResults: [],
  };

  miniSearch: any;

  componentDidMount() {
    this.miniSearch = new MiniSearch({
      fields: ['question', 'answer_text'], // fields to index for full-text search
      storeFields: ['question', 'answer_json'], // fields to return with search results
    });
    this.miniSearch.addAll(this.state.results);
  }

  handleSearch = (event: any) => {
    const results = this.miniSearch.search(event.target.value, {
      prefix: true,
      fuzzy: 0.2,
    });
    this.setState({
      searchWord: event.target.value,
      searchResults: results,
      loadLimit: 5,
    });
  };

  loadMoreButton = () => {
    this.setState((state: any) => ({ loadLimit: state.loadLimit + 5 }));
  };
  render() {
    return (
      <div>
        <TopSection>
          <SectionTop>
            <HeadingSection>{this.props.messages?.FAQPageTitle}</HeadingSection>
            <SearchBar>
              <StyledInput
                onChange={this.handleSearch}
                value={this.state.searchWord}
                placeholder={this.props.messages?.FAQSearch}
              />
            </SearchBar>
          </SectionTop>
        </TopSection>
        <SectionOne>
          {this.state.searchWord.length > 0 ? (
            this.state.searchResults.length === 0 ? (
              <SorryNoContent>
                {this.props.messages?.FAQNoResult}
              </SorryNoContent>
            ) : (
              this.state.searchResults
                .slice(0, this.state.loadLimit)
                .map((item: any, key: any) => {
                  return (
                    <FaqContainer key={key}>
                      <FaqQuestion>{item.question}</FaqQuestion>
                      <FaqAnswer>
                        {documentToReactComponents(item.answer_json)}
                      </FaqAnswer>
                    </FaqContainer>
                  );
                })
            )
          ) : (
            this.state.results
              .slice(0, this.state.loadLimit)
              .map((item: any, key: any) => {
                return (
                  <FaqContainer key={key}>
                    <FaqQuestion>{item.question}</FaqQuestion>
                    <FaqAnswer>
                      {documentToReactComponents(item.answer_json)}
                    </FaqAnswer>
                  </FaqContainer>
                );
              })
          )}
          {(this.state.searchWord.length > 0
            ? this.state.searchResults
            : this.state.results
          ).length > this.state.loadLimit && (
            <BlueButtonWrapper>
              <BlueButtonNew
                id="faq_section__load_more"
                onClick={this.loadMoreButton}
              >
                {this.props.messages?.FAQPageLoadMoreButton}
              </BlueButtonNew>
            </BlueButtonWrapper>
          )}
        </SectionOne>
      </div>
    );
  }
}
